import { Pipe, PipeTransform } from "@angular/core";
import { Language } from "../interfaces/language.interface";


@Pipe({
  name: 'allowLanguage'
})
export class CheckLanguagePipe implements PipeTransform {
  transform(languages: Language[], ...args: any[]): any {
    if(languages) {
        return languages.filter(object => {
            return object.allow != false;
        });
    }
  }
}
